// noinspection JSUnresolvedVariable

import {createReplaceableElement} from "../helpers/replaceableElement";
import {setAsDateField, setAsSelect2} from "../helpers/inputs";
import {showLoading} from "../helpers/loading";
import Axios from "axios";
import handleAjaxError from "../helpers/handleAjaxError";
import createElement from "../helpers/createElement";
import {getInputsByName} from "../helpers/forms";
import {getSingleInputByNameV3} from "../helpers/inputs/forms/fornInputHelpers";

function initCustomerIncomingInvoicesIndex() {
	// Init card components
	document.querySelectorAll('.invoices-card').forEach(card => {
		const cardComponentInstance = createReplaceableElement({
			element: card,
			init() {
				// Setup filters
				const categoryFilter = this.getCategoryFilter();

				setAsSelect2(categoryFilter);

				$(categoryFilter).on('change', () => refreshCard(cardComponentInstance))

				// Setup dates filters
				this.element.querySelectorAll('.date-only-input').forEach(input => {
					setAsDateField(input, {
						showClear: true,
					});

					$(input).on('dp.hide', () => refreshCard(cardComponentInstance))
				})

				// Setup 'due in' filter
				this.element.querySelectorAll('select[name="dueIn"]').forEach(select => {
					select.addEventListener('change', () => {
						refreshCard(cardComponentInstance);
					})
				})

				// Setup print pdf button
				this.element.querySelectorAll('.print-pdf-button').forEach(button => {
					button.addEventListener('click', () => {
						window.open(button.dataset.printUrl, '_blank');
					})
				})
			},
			getCategoryFilter() {
				return this.element.querySelector('select[name="category_filter"]');
			},
		})

	});


	// Check for 'all-pending' in query string
	const urlParams = new URLSearchParams(window.location.search);
	if (urlParams.has('all-pending')) {
		// Scroll to bottom
		window.setTimeout(() => {
			window.scroll({
				top: 10000,
				behavior: 'smooth',
			})
		}, 32)
	}

	// Methods

	function refreshCard(invoicesCardComponent) {
		showLoading(invoicesCardComponent.element);

		const data = {
			category_id: invoicesCardComponent.getCategoryFilter().value,
		}

		const dateFilters = getInputsByName(invoicesCardComponent.element, ['from', 'to']);

		data.from = dateFilters.from ? dateFilters.from : undefined;
		data.to = dateFilters.to ? dateFilters.to : undefined;

		// Due in filter
		data.dueIn = getSingleInputByNameV3(invoicesCardComponent.element, 'dueIn');

		Axios.post(getSingleInputByNameV3(invoicesCardComponent.element, 'refreshRoute'), data)
			.then(response => {
				const card = createElement(response.data.card);

				invoicesCardComponent.replace(card);
			})
			.catch(handleAjaxError)
			.finally(stopLoading)
	}
}

export {initCustomerIncomingInvoicesIndex}
